export default __webpack_public_path__ + "locales/it/DeleteSelfProfileDialog.json?hash=47fec6f38ed03b8771cfee14d23f186c";